// extracted by mini-css-extract-plugin
export default {"dialogRoot":"TeamsDialog_dialogRoot__vU6CH","dialogActionBtn":"TeamsDialog_dialogActionBtn__vyPua"};